const weekdayOrder = ["ma", "ti", "ke", "to", "pe", "la", "su"];
const weekdayNames = {
  ma: "maanantai",
  ti: "tiistai",
  ke: "keskiviikko",
  to: "torstai",
  pe: "perjantai",
  la: "lauantai",
  su: "sunnuntai",
};

export default function Hours({ openingHours }) {
  const today = new Date();
  const todayKey = ["su", "ma", "ti", "ke", "to", "pe", "la"][today.getDay()];
  const todayHours = openingHours?.[todayKey] || "-";

  return (
    <div className="max-w-80">
      <ul className="space-y-1">
        {weekdayOrder.map((key, index) => (
          <li
            key={key}
            className={`flex justify-between py-1 ${
              key === todayKey ? "font-bold" : ""
            } ${index === 0 ? "mt-2 border-t border-b" : "mt-2 border-b"}`}
          >
            <span>{weekdayNames[key]}</span>
            <span>{openingHours?.[key] || "-"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
